<template>
	<div id="app">
		<div class="picContent">
			<HeaderNavigation></HeaderNavigation>
			<router-view></router-view>
		</div>
		<picFooter class="picFooter"></picFooter>
	</div>
</template>

<style>
:root {
	--main-text-color: #0e2b42;
	--topic1-color: #f5e854;
	--topic2-color: #00d392;
	--topic3-color: #008cd3;
	--topic4-color: #b74a7f;
	--primary-color: #304eea;
	--element-headline-color: #6a798c;
}

body {
	position: relative;
	width: 100%;
	color: #17314d;
	height: 100%;
	margin: 0;
	padding: 0;
	overflow-x: hidden;
	scroll-behavior: smooth;
}

figcaption {
	font-size: 14px;
	font-style: italic;
}

html,
body {
	height: 100%;
	/* overflow-x: hidden; */
}

#app {
	font-family: Raleway, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: var(--main-text-color);
	display: flex;
	flex-direction: column;
	height: 100%;
}

h1,
h2,
h3,
h4,
h5 {
	font-weight: 700;
	color: #0e2b42;
}

.main-content h2 {
	font-size: 1.3rem;
}

.main-content h3 {
	font-size: 1rem;
}

p,
li,
ul,
ol {
	line-height: 1.8;
}

a {
	color: var(--main-text-color);
}

article {
	display: block;
}

video:focus {
	outline: none;
}

.link {
	color: var(--primary-color);
	text-decoration: underline;
}

.arrow-right-icon {
	background-image: url("assets/icons/arrow-right.svg");
	width: 40px;
	height: 40px;
	background-repeat: no-repeat;
	background-size: contain;
	transform: translateY(-4px);
	/*margin-right: 4px;*/
}

.arrow-down-circle-icon {
	background-image: url("assets/icons/arrow-down-circle.svg");
	height: 32px;
	width: 32px;
}

.chevron-down-icon {
	background-image: url("assets/icons/chevron-down.svg");
	width: 32px;
	height: 32px;
}

.example-icon {
	background-image: url("assets/icons/example.svg");
	width: 24px;
	height: 24px;
}

.favourite-icon {
	background-image: url("assets/icons/favorite.svg");
	width: 24px;
	height: 24px;
	transform: translateY(4px);
	margin-right: 4px;
}

.menu-icon {
	background-image: url("assets/icons/menu.svg");
	width: 24px;
	height: 24px;
}

.down-page-icon {
	background-image: url("assets/icons/chevron-down.svg");
	background-color: #f1f4f6;
	border-radius: 50%;
	width: 32px;
	height: 32px;
}

.save-icon {
	background-image: url("assets/icons/save.svg");
	height: 18px;
	width: 18px;
}

.save-icon:hover {
	background-image: url("assets/icons/save_active.svg");
}

.document-icon {
	background-image: url("assets/icons/document.svg");
	height: 40px;
	width: 40px;
}

.favourite {
	display: flex;
	align-items: baseline;
	margin-left: 16px;
	cursor: pointer;
}

@media (min-width: 1200px) {
	.container,
	.container-sm,
	.container-md,
	.container-lg,
	.container-xl {
		max-width: 1340px;
	}
}

@media (min-width: 992px) {
	.col-lg-3 {
		flex: 0 0 20%;
		max-width: 20%;
	}

	.col-lg-7 {
		flex: 0 0 61.333333%;
		max-width: 61.333333%;
	}
}

.picContent {
	flex: 1 0 auto;
}

.picFooter {
	flex-shrink: 0;
}

.hotJumpAnchor {
	margin-top: -60px;
	padding-top: 60px;
}

.subHotJumpAnchor {
	margin-top: -40px;
	padding-top: 60px;
}

.scrollIcon::after {
	content: url("./assets/icons/scroll.svg");
	position: absolute;
	top: 20px;
	right: 0px;
	transition: ease 300ms;
}

.scrollIcon:hover::after {
	content: url("./assets/icons/scroll.svg");
	position: absolute;
	right: -70px;
}

.interLink {
	background-image: linear-gradient(#e5c4d4, #e5c4d4);
	background-repeat: no-repeat;
	background-position: 10% 100%;
	background-size: 100% 7px;
	transition:
		background-size 0.5s,
		background-position 0.3s ease-in 0.5s;
	padding: 0 2px;
	text-decoration: none;
	color: var(--main-text-color);
	font-weight: bold;
	cursor: pointer;
}

.interLink:hover {
	background-size: 100% 100%;
	transition:
		background-position 0.5s,
		background-size 0.3s ease-in 0.1s;
	text-decoration: none;
	color: var(--main-text-color);
}

.smallSpaceOnTop {
	padding-top: 18px;
}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import HeaderNavigation from '@/components/navigation/HeaderNavigation.vue';
import picFooter from '@/components/navigation/picFooter.vue';

export default {
	components: {
		HeaderNavigation,
		picFooter,
	},
};
</script>
